/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { withRouter } from "react-router";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";

import "react-datepicker/dist/react-datepicker.css";
import { Button, Card, TextField } from "@mui/material";
import { InfinitySpin } from "react-loader-spinner";

class EventLeads extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      restaurent: [],
      restaurent_outlet: [],
      restro_id: "",
      start_date: "",
      rest: "",
      end_date: "",
      type: "",
      currentPage: 1,
      page: 1,

      totalPages: 1,
      total: "",
      eventtotal: 0,

      per_page: 10,
      queryStartDate: "",
      queryEndDate: "",
      queryFilterBy: "",
      queryRestroId: "",
      hitFilterBtn:0,
      isFilterValid: true,

    };

    this.fetchData = this.fetchData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
    this.fetchQueryParam = this.fetchQueryParam.bind(this);
    this.QueryEventsFilter = this.QueryEventsFilter.bind(this);
  }

  componentDidMount() {
    // this.fetchData();
    this.fetchRestData();
    this.fetchOutletData();
    this.fetchQueryParam();

  }

  componentDidUpdate(prevProps) {
    // Check if the query parameters have changed
    if (this.props.location.search !== prevProps.location.search) {
      this.fetchQueryParam();
    }
  }

  fetchQueryParam() {
    const query = new URLSearchParams(this.props.location.search);
    const start_date = query.get("start_date");
    const end_date = query.get("end_date");
    const restro_id = query.get("restro_id");
    const type = query.get("type");

    if (start_date && end_date) {
      this.setState({ start_date, end_date, type, rest: restro_id, hitFilterBtn: 1 }, () => {
        this.QueryEventsFilter(start_date, end_date, type, restro_id);
      });
    } else if (restro_id) {
      this.setState({rest: restro_id,hitFilterBtn: 1 }, () => {
        this.QueryEventsFilter(start_date, end_date, type, restro_id);
      });
    } else if (start_date && end_date && restro_id) {
      this.setState({ start_date, end_date, type, rest: restro_id ,hitFilterBtn: 1}, () => {
        this.QueryEventsFilter(start_date, end_date, type, restro_id);
      });
    } else {
      if(this.state.hitFilterBtn===0){
        this.fetchData(this.state.page, this.state.per_page);

      }
    }
  }

  QueryEventsFilter(startDate, endDate, filterBy, RestroId, page = this.state.page, per_page = this.state.per_page) {
    if (!startDate && !endDate && !filterBy && !RestroId) {
      alert("Please Select Any Filter");
      return;
    }

    if (startDate && !endDate) {
      alert("Please select end date");
      return;
    }

    if (endDate && !startDate) {
      alert("Please select start date");
      return;
    }

    const end_date = endDate;
    const start_date = startDate;
    const rest = RestroId ? RestroId : '';
    const type = filterBy;

    const user = JSON.parse(localStorage.getItem("user"));
    const user_id = user.id;
    const restro_id = user.restro_id;

    axios
      .post(endpoints.eventFilter, {
        start_date,
        end_date,
        rest,
        type,
        user_id,
        restro_id,
        page,
        per_page
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          totalevent: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
        // console.log(response.data);
      });
  }


  handlePageChange(page) {
    if (this.state.hitFilterBtn === 0) {
      this.fetchData(page, this.state.per_page);
    } else if (this.state.isFilterValid) {
      this.QueryEventsFilter(
        this.state.start_date,
        this.state.end_date,
        this.state.type,
        this.state.rest,
        page,
        this.state.per_page
      );
    }
  }

  handlePerRowsChange(newPerPage, page) {
    this.setState({ per_page: newPerPage }, () => {
      if (this.state.hitFilterBtn === 0) {
        this.fetchData(page, newPerPage);
      } else if (this.state.isFilterValid) {
        this.QueryEventsFilter(
          this.state.start_date,
          this.state.end_date,
          this.state.type,
          this.state.rest,
          page,
          newPerPage
        );
      }
    });
  }

  fetchData(page,per_page) {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let type = "1";

    let restro_id = b.restro_id;
 
    axios
      .post(endpoints.getBooking, {
        restro_id,
        type,
        page,
        per_page
      })
      .then((response) => {
        // window.location.reload(true);

        this.setState({
          items: response.data.data,
          totalevent: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
        // console.log(response.data.data);
      });
  }
  fetchRestData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios.post(endpoints.getRestaurentsDropDown, {}).then((response) => {
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
      // console.log(response.data);
    });
  }

  fetchOutletData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios
      .post(endpoints.getOutlet, {
        restro_id,
        user_id,
      })
      .then((response) => {
        this.setState({
          restaurent_outlet: response.data.data,
          total: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
        //  console.log('outlet ', response.data);
      });
  }


  parseEventDetail = (eventDetail) => {
    let parsedData;

    try {
      parsedData = JSON.parse(eventDetail);
      if (typeof parsedData === 'string') {
        parsedData = JSON.parse(parsedData);
      }
    } catch (e) {
      console.error('Error parsing eventDetail:', e);
    }

    return parsedData;
  }

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;

    const b = this.state.total;

    const links = this.state.restaurent;
    const outlets = this.state.restaurent_outlet;
    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;
    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    const ExpandedComponent =
      (suppData) =>
      ({ data }) => {
        // const a = JSON.parse(data, null, 2)

        const myArray = this.parseEventDetail(data.event_detail);
        // console.log(myArray, 'myArray')
        return (
          <>
            <div className="row px-5">
              <div className="col-md-8">
                <mat-card>
                  <table>
                    <tr>
                      <th className="w-50">Name :</th>
                      <td>{data.full_name}</td>
                    </tr>
                    <tr>
                      <th>Email :</th>
                      <td>{data.email}</td>
                    </tr>
                    <tr>
                      <th>Mobile : </th>
                      <td>{data.phone_no}</td>
                    </tr>
                    <tr>
                      <th>Event Date :</th>
                      <td>{data.event_date}</td>
                    </tr>

                    <tr>
                      <th>Address : </th>
                      <td>{data.address}</td>
                    </tr>
                    <tr>
                      <th> Transaction ID : </th>
                      <td>{data.transcation_id}</td>
                    </tr>
                  </table>
                </mat-card>
              </div>

              <div className="col-md-4">
                <mat-card>
                  <table>
                    <tr>
                      <th> Couple : </th>
                      <td>{myArray.couple}</td>
                    </tr>
                    <tr>
                      <th> Male : </th>
                      <td>{myArray.male_stag}</td>
                    </tr>
                    <tr>
                      <th> Female : </th>
                      <td>{myArray.male_stag}</td>
                    </tr>
                    <tr>
                      <th> Other : </th>
                      <td>{myArray.others_stag}</td>
                    </tr>
                    <tr>
                      <th> Price : </th>
                      <td>{data.price}</td>
                    </tr>

                    <tr>
                      <th> Order ID : </th>
                      <td>{data.razorpay_order_id}</td>
                    </tr>
                  </table>
                </mat-card>
              </div>
            </div>
            {suppData}{" "}
          </>
        );
      };

    const columns = [
      {
        selector: (row) => row.full_name,
        cellExport: (row) => row.full_name,
        sortable: true,
      },
      {
        selector: (row) => row.event_name,
        cellExport: (row) => row.event_name,
        sortable: true,
      },
      {
        selector: (row) => row.phone_no,
        cellExport: (row) => row.phone_no,
        sortable: true,
      },
      {
        selector: (row) =>
          row.event_date === "Event Date" ? "Event Date" : row.event_date,
        cellExport: (row) => row.event_date,
        sortable: true,
      },
      {
        selector: (row) => row.event_detail,
        cellExport: (row) => row.event_detail,
        sortable: true,
        omit: true,
      },
      {
        selector: (row) => row.restro_name,
        cellExport: (row) => row.restro_name,
        sortable: true,
      },
      {
        selector: (row) => row.address,
        cellExport: (row) => row.address,
        sortable: true,
        omit: true,
      },
      {
        selector: (row) => row.price,
        cellExport: (row) => row.price,
        sortable: true,
        omit: true,
      },
      {
        selector: (row) => row.transcation_id,
        cellExport: (row) => row.transcation_id,
        sortable: true,
        omit: true,
      },
      {
        selector: (row) => row.razorpay_order_id,
        cellExport: (row) => row.razorpay_order_id,
        sortable: true,
        omit: true,
      },
    ];

    const onSubmit = async (e) => {
      this.filterfetch(e);
      // console.log(e)
    };


   const bFilter = () => {
      const { start_date, end_date, type, rest } = this.state;
    
      // Check if at least one filter is selected
      if (!start_date && !end_date && !type && !rest) {
        alert("Please Select Any Filter");
        this.setState({ isFilterValid: false });
        return;
      }
    
      this.setState({ isFilterValid: true, hitFilterBtn: 1 });
    
      // Fetch the data with the selected filters
      this.QueryEventsFilter(
        start_date,
        end_date,
        type,
        rest
      );
    
      this.props.history.replace({ search: "" });
    };
    


    const onStartChange = (e) => {
      this.setState({ start_date: e.target.value });
    };
    const onEndChange = (e) => {
      this.setState({ end_date: e.target.value });
    };
    const onTypeChange = (e) => {
      this.setState({ type: e.target.value });
    };

    const onRestChange = (e) => {
      this.setState({ rest: e.target.value });
    };
    const c = [
      {
        event_date: "Event Date",
        event_name: "Event Name",
        event_detail: "Event Detail",
        full_name: "Name",
        phone_no: "Number",
        address: "Address",
        restro_name: "Restaurant",
        price: "Price",
        transcation_id: "Transaction Id",
        razorpay_order_id: "Order Id",
      },
    ];
    // const data = heading.concat(c);
    const data = c.concat(a);

    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Event Leads</h2>
        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <label>Start Date</label>
                <br />
                <TextField
                  fullWidth
                  id="start_date"
                  label="Start Date"
                  type="date"
                  name="start_date"
                  place="Start Date"
                  value={this.state.start_date}
                  onChange={(e) => onStartChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              <div className="col-md-3">
             
                <label>End Date</label>
                <br />
                <TextField
                  fullWidth
                  id="end_date"
                  label="End Date"
                  type="date"
                  name="end_date"
                  place="End Date"
                  onChange={(e) => onEndChange(e)}
                  value={this.state.end_date}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                  // InputProps={{
                  //   readOnly: true,
                  //  }}
                />
              </div>

              <div className="col-md-3">
                <label>Filter By</label>
                <select
                  name="status"
                  required
                  className="form-control"
                  defaultValue="2"
                  onChange={(e) => onTypeChange(e)}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {/* <option value="1">By Event Date</option> */}
                  <option value="2" disabled>
                    By Created Date
                  </option>
                </select>
              </div>

              {this.restro_id === 0 ? (
                <div className="col-md-3">
                  <label>Restaurant</label>
                  <select
                    name="rest"
                    required
                    className="form-control"
                    value={this.state.rest}
                    onChange={(e) => onRestChange(e)}
                  >
                    <option value="">Select Restaurant</option>
                    {links.map((e, key) => {
                      return (
                        <option key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : (
                ""
              )}
              <div className="col col-3">
                <div className="mt-5 text-center">
                  <Button
                    className="w-50"
                    onClick={() => bFilter()}
                    variant="contained"
                    style={{ color: "white" }}
                    size="medium"
                  >
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Card>
        <div className="row mt-2">
          <DataTableExtensions {...tableData} filter={false}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationServer
              highlightOnHover
              paginationTotalRows={this.state.totalevent}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handlePerRowsChange}
              progressPending={!this.state.DataisLoaded}
              expandableRows
              expandableRowsComponent={ExpandedComponent()}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(EventLeads);
